import React, { useEffect, useState } from "react";
import axios from "axios";
import "./international.css";

const InternationalMembers = ({ categoryName, onBack }) => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    fetchMembers();
  }, [categoryName]);

  const fetchMembers = async () => {
    try {
      const res = await axios.post(
        "https://lionsdirectoryapi.emedha.in/international/get",
        { route: categoryName }
      );
      setMembers(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const callMember = (mobile) => {
    window.open(`tel:${mobile}`);
  };

  const messageMember = (mobile) => {
    window.open(`https://wa.me/${mobile}`);
  };

  const emailMember = (email) => {
    if (!email) return;
    window.open(`mailto:${email}`);
  };

  return (
    <div className="container">
      {/* Header */}
      <div className="header">
        <div className="header-left">
          <button className="back-btn" onClick={onBack}>←</button>
          <h5>{categoryName}</h5>
        </div>
      </div>

      {/* Members */}
      <div className="content">
        {members.map((member, index) => (
          <div key={index} className="member-card">
            <div className="avatar">
              {member.photo ? (
                <img src={member.photo} alt="avatar" />
              ) : (
                <span>{member.name?.charAt(0)}</span>
              )}
            </div>

            <div className="member-info">
              <h4>{member.name}</h4>
              <p className="designation">{member.position}</p>
              <p className="description">{member.description}</p>

              <p
                className="email"
                onClick={() => emailMember(member.email)}
              >
                {member.email}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InternationalMembers;